import { useMemo } from "react";

import {
  generateFormSchemaForParameters,
  generateFormTemplateForParameters,
  generateInputFieldForParameters,
  getTemplateContent,
  processTemplateForParameters,
} from "./utils";

import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";

import { Button } from "V2.0/common/button";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";

const AttributesAction = (props) => {
  const { onCancel, isUpdateDisabled, onUpdate } = props;
  return (
    <>
      <Button
        outline
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button
        disabled={isUpdateDisabled}
        onClick={onUpdate}
      >
        Update
      </Button>
    </>
  );
};

const ViewMessageAction = (props) => {
  const { onClose } = props;
  return (
    <Button
      outline
      onClick={onClose}
    >
      Close
    </Button>
  );
};

export default function WhatsappTemplateAttributesAdd(props) {
  const { parametersInitialValues, template, onUpdateParameters, onClose } =
    props;

  const templateContents = useMemo(() => {
    const _templateContents = getTemplateContent(template);

    return _templateContents;
  }, [template]);

  const parameters = useMemo(() => {
    return processTemplateForParameters(template);
  }, [template]);

  const fieldsTemplate = useMemo(
    () => generateFormTemplateForParameters(parameters),
    [parameters]
  );

  const schema = useMemo(
    () => generateFormSchemaForParameters(parameters),
    [parameters]
  );

  const inputField = useMemo(() => {
    if (Boolean(Object.keys(parametersInitialValues).length)) {
      return parametersInitialValues;
    }

    return generateInputFieldForParameters(parameters);
  }, [parameters, parametersInitialValues]);

  const { data, handleChange, validate, error } = useForm(inputField, schema);

  function handleUpdate() {
    console.log({ parameters, data });
    onUpdateParameters(data);
    onClose();
  }

  const isUpdateDisabled =
    validate(data, schema) || Boolean(Object.keys(error).length);

  const title = parameters?.length === 0 ? "View Message" : "Update Attributes";

  return (
    <Dialog
      size="md"
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>
        <div className="flex flex-col gap-y-2 mb-4">
          <p className="text-sm font-semibold">Content</p>
          <div className="border rounded-lg p-4 text-sm font-light text-gray-500 flex flex-col gap-y-2">
            {Object.keys(templateContents).map((content, idx) => {
              const textContent = templateContents[content];

              if (textContent) {
                return (
                  <p
                    className="whitespace-pre-line"
                    key={idx}
                  >
                    {textContent}
                  </p>
                );
              }
            })}
          </div>
        </div>
        <Form
          data={data}
          handleChange={handleChange}
          error={error}
          template={fieldsTemplate}
        />
      </DialogBody>
      <DialogActions>
        {parameters.length === 0 ? (
          <ViewMessageAction onClose={onClose} />
        ) : (
          <AttributesAction
            onCancel={onClose}
            onUpdate={handleUpdate}
            isUpdateDisabled={isUpdateDisabled}
          />
        )}
      </DialogActions>
    </Dialog>
  );
}
